import React, { useCallback, useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { Link } from 'react-router-dom';

const temp = () => {};

export default function DragDropSingle({
  onSave,
  setPopupVisible,
  croppedImage,
  setCroppedImage,
  fetchedPhoto = "",
  setFormErrors = temp,
  disable = "false",
  infoText = "Upload profile image for this user here",
  maxSizeMB = null,
  errorKey = "branding_photo",
}) {
  const [data, setData] = useState([]);
  const [currentURI, setCurrentURI] = useState();
  const [fileError, setFileError] = useState(null);

  const maxSizeBytes = maxSizeMB ? maxSizeMB * 1024 * 1024 : undefined;

  const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
    if (rejectedFiles?.length) {
      const rejection = rejectedFiles[0];
      const isTooLarge = rejection?.errors?.some((err) => err.code === 'file-too-large');
      const message = isTooLarge && maxSizeMB
        ? `File is too large. File limit ${maxSizeMB} MB.`
        : 'Invalid file. Please upload a JPG or PNG image.';
      setFileError(message);
      return;
    }

    setFileError(null);
    setFormErrors((prevState) => ({
      ...prevState,
      [errorKey]: null,
    }));

    acceptedFiles.forEach((file) => {
      setData((prevState) => [...prevState, file]);
      setPopupVisible(true);
    });
  }, [errorKey, maxSizeMB, setFormErrors, setPopupVisible]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    disabled: disable === "true" ? true : false,
    maxFiles: 1,
    multiple: false,
    ...(maxSizeBytes ? { maxSize: maxSizeBytes } : {}),
    accept: {
      'image/*': ['.png', '.jpg', '.jpeg'],
    },
  });

  const handleFileDelete = (file) => {
    let tempData = [...data];
    tempData.splice(tempData.indexOf(file), 1);
    setData(tempData);
  }

  // Converting the current image to BASE-64 URI string,
  // so that it could be used with <Img>:src tag.
  const getBase64 = (file) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setCurrentURI(reader.result);
    };
  }

  useEffect(() => {
    onSave(data);
  }, [data]);

  useEffect(() => {
    if (croppedImage) {
      setCurrentURI(croppedImage.src);
      setData([]);
      setFileError(null);
    }
  }, [croppedImage]);

  return (
    <div className="file-upload-form">
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <div className="picimg">
          {
            (currentURI) ?
            croppedImage ?
              <div className="crop-sec">
                <img src={currentURI} alt="cover_file" />
                <span className="ms-2">
                  <Link to="#" onClick={() => setCroppedImage(null)}>
                      <img src="../img/removeIcon.svg" alt="" />
                  </Link>
                </span>
              </div>
              : data.map((file, index) => (
              <div className="imgcol" key={index}>
                <img src={getBase64(file) || currentURI} alt="" />
                <span className="ms-2">
                  <Link to="#" onClick={() => handleFileDelete(file)}>
                      <img src="../img/removeIcon.svg" alt="" />
                  </Link>
                </span>
              </div>
            )) : <img src={fetchedPhoto || "../img/upload.jpg"} alt="" />
          }
        </div>
        <span className="text-center infotxt">{infoText}</span>
      </div>
      {maxSizeMB && (
        <small className="fileinput d-block text-center mt-2">(File limit {maxSizeMB} MB)</small>
      )}
      {fileError && <span className="error d-block text-center mt-1">{fileError}</span>}
    </div>
  );
}
